import React from 'react';

import { Skeleton } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';
import { spacing } from 'styles/constants';

// import theme from './theme';

const CardSkeleton = Skeleton.withConfig({
  // width: theme.cardWidth,
  height: 32,
  borderRadius: 4,
});

export const UpsellSkeleton = () => {
  return (
    <Box style={styles.container} testID="upsell-skeleton-loader">
      <CardSkeleton />
      <CardSkeleton />
    </Box>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    gap: spacing.$4,
  },
});
